import { isPlatformBrowser } from '@angular/common';
import { Component, Inject, Input, PLATFORM_ID, ViewChild } from '@angular/core';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { OrderService } from '../../services/order.service';
import { Order, OrderStatus, PaymentStatus } from '../../interface/order.interface';

@Component({
  selector: 'app-order-history-modal',
  templateUrl: './order-history-modal.component.html',
  styleUrl: './order-history-modal.component.scss'
})
export class OrderHistoryModalComponent {
  @ViewChild('historyModal') historyModal!: any;

  @Input() order: Order;

  historyStatusList: any[] = [];

  constructor(
    private modalService: NgbModal,
    private activeModal: NgbActiveModal,
    @Inject(PLATFORM_ID) private platformId: Object,
    private orderService: OrderService
  ) { }

  ngOnInit() { }

  getOrderHistoryStatus() {
    const body = {
      orderId: this.order.orderId,
      isAscending: false
    }

    this.orderService.getOrderHistoryStatus(body).subscribe((res: any) => {
      if (res) {
        this.historyStatusList = res || [];
      }
    });
  }

  async openModal() {
    if (isPlatformBrowser(this.platformId)) {
      // For SSR
      this.getOrderHistoryStatus();
      this.modalService
        .open(this.historyModal, {
          ariaLabelledBy: 'address-add-Modal',
          centered: true,
          windowClass: 'theme-modal modal-login',
        })
    }
  }

  closeModal() {
    this.activeModal.dismiss();
  }

  getOrderStatus(status: OrderStatus) {
    switch (status) {
      case OrderStatus.Created:
        return { value: "Đang xác nhận", icon: "created" };
      case OrderStatus.Progressing:
        return { value: "Đang xử lý", icon: "progressing" };
      // case OrderStatus.Packing:
      //   return { value: "Đã Đóng Gói", icon: "progressing"}
      case OrderStatus.Shipping:
        return { value: "Đang vận chuyển", icon: "shipping" };
      case OrderStatus.Done:
        return { value: "Đã Hoàn Thành", icon: "done" };
      case OrderStatus.Cancelled:
        return { value: "Đã hủy", icon: "cancelled" };
      case OrderStatus.Paid:
        return { value: "Đã thanh toán", icon: "paid" };
      case OrderStatus.PartialPaid:
        return { value: "Thanh toán một phần", icon: "partial-paid" };
      case OrderStatus.Slipted:
        return { value: "Đã tách đơn", icon: "slipted" };
      default:
        return { value: "Không xác định", icon: "progressing" };
    }
  }

  getPaymentStatus(status: PaymentStatus | undefined) {
    switch (status) {
      case PaymentStatus.Paid:
        return { value: "Đã thanh toán", icon: "paid" };
      case PaymentStatus.Unpaid:
        return { value: "Chưa thanh toán", icon: "unpaid" };
      case PaymentStatus.PartialPaid:
        return { value: "Thanh toán một phần", icon: "partial-paid" };
      default:
        return { value: "Chưa thanh toán", icon: "unpaid" };
    }
  }
}
